module.exports = __webpack_public_path__ + "static/media/Info.0c4d8fbd.svg";